module.exports = __webpack_public_path__ + "img/blog-author.d465218e.jpg";